<script setup lang="ts">
import { PromotionKind } from '~/lib/services/promos/promos.dto'
import { PromosBlockType } from '~/lib/services/store/catalog/cart.dtos'

const props = withDefaults(
  defineProps<{
    promosBlock: PromosBlockType
    promotionStr?: string
  }>(),
  {
    promotionStr: undefined,
  }
)

const { t } = useLocale()
const { translateInterpolated } = useTranslation()
const { format } = useFormatAmount()
const { appliedPromotions } = usePromotions()

const appliedPromotion = computed(() => appliedPromotions.value?.[0] || undefined)

const discountStr = computed(() => {
  if (props.promosBlock.discount) {
    if (props.promotionStr) return translateInterpolated(props.promotionStr)
    else if (appliedPromotion.value) {
      const { code, kind } = appliedPromotion.value
      return kind === PromotionKind.COUPON
        ? `${t('shoppingCart.promotions.addPromo.prefix.applied')} <b>${code}</b>`
        : `${t('shoppingCart.promotions.addPromo.prefix.applied')} <b>${t(
            'shoppingCart.promotions.addPromo.prefix.employee'
          ).toUpperCase()}</b>`
    }
  }
  return ''
})
</script>

<template>
  <div
    v-if="discountStr"
    class="flex flex-row items-center justify-between text-sm text-mcd-secondaryDarkGrey"
  >
    <p
      v-dompurify-html="discountStr"
      class="max-w-[60%] truncate"
      data-test="cart-amount-row--promos-applied"
    ></p>
    <span class="block">-&nbsp;{{ format(promosBlock.discount) }}</span>
  </div>
</template>
